import { ProductDataType } from 'utils/types';
import { Section } from 'utils/types/contentfulTypes';

import { ProductTierSectionProps } from './ProductTierSection';

export default function parseProductListData(
  section: Section,
  productsWithSpreeData: Record<string, ProductDataType>,
): ProductTierSectionProps {
  return {
    displayName: section.displayName,
    metadata: section.metadata,
    productsWithSpreeData: productsWithSpreeData,
  };
}
